import React, { memo } from 'react';
import cn from 'classnames';

import tabsStyles from '@creditflowresearch/uilib/styles/tabs.module.scss';

interface ITab {
  name: string,
  key: string | number,
  isDisabled: boolean,
}

interface ITabsProps<T extends ITab> {
  tabs: T[],
  onSelect: (name: string) => void,
  dataTest: string,
  activeTab?: string,
  className?: string,
}

const Tabs = ({ tabs, activeTab = '', onSelect, dataTest, className }: ITabsProps<ITab>) => (
  <>
    { tabs.map((tab: ITab) => (
      <button
        key={ tab.key }
        type="button"
        data-test={ `${ dataTest }-${ tab.name.toLowerCase() }` }
        onClick={ () => !tab.isDisabled && onSelect(tab.name) }
        className={ cn(tabsStyles.tab, className, {
          [tabsStyles.isTabActive]: activeTab === tab.key,
          [tabsStyles.isTabDisabled]: tab.isDisabled || false,
        }) }
      >
        <span>{ tab.name }</span>
      </button>
    )) }
  </>
);

export default memo(Tabs);
